<!--
  --
  -- 組織情報 コンポーネント
  --
  -->
<template>
  <div class="text-center">
    <span class="font-weight-bold">{{orgname}}</span>
  </div>
</template>

<script>
export default {
  name: 'CCredit',
  computed: {
    orgname () {
      return this.getters['org/name']
    },
    version () {
      return `v${process.env.VUE_APP_VERSION}`
    }
  }
}
</script>
